import { render, staticRenderFns } from "./Topbar.vue?vue&type=template&id=53a35c46"
import script from "./Topbar.vue?vue&type=script&lang=js"
export * from "./Topbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Topbar.vue?vue&type=custom&index=0&blockType=i18n&lang=json&locale=pl&scope=local"
if (typeof block0 === 'function') block0(component)
import block1 from "./Topbar.vue?vue&type=custom&index=1&blockType=i18n&lang=json&locale=en&scope=local"
if (typeof block1 === 'function') block1(component)

export default component.exports